import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/messaging';
import fbConfig from '../configs/firebase.config';

export const firebaseEventsApp = firebase.initializeApp(
  fbConfig.eventsDbConfig,
  'events'
);
export const firebaseOperationsApp = firebase.initializeApp(
  fbConfig.operationsDbConfig,
  'operations'
);
export const firebaseMasterApp = firebase.initializeApp(
  fbConfig.masterDbConfig,
  'master'
);



// EMULATOR CONFIG — enabled via REACT_APP_USE_EMULATORS=true in .env
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  console.log('🔥 Using Firebase Emulators');
  try {
    firebaseOperationsApp.auth().useEmulator('http://localhost:9092');
    firebaseEventsApp.auth().useEmulator('http://localhost:9092');
    firebaseMasterApp.auth().useEmulator('http://localhost:9092');
    // Long polling avoids the WebChannel transport dropping to "client is
    // offline" during local emulator use; the SDK then surfaces real errors.
    firebaseEventsApp.firestore().settings({
      host: 'localhost:8082',
      ssl: false,
      experimentalForceLongPolling: true,
    });
    firebaseOperationsApp.firestore().settings({
      host: 'localhost:8082',
      ssl: false,
      experimentalForceLongPolling: true,
    });
    firebaseMasterApp.firestore().settings({
      host: 'localhost:8082',
      ssl: false,
      experimentalForceLongPolling: true,
    });
    firebaseOperationsApp.functions().useEmulator('localhost', 5002);
  } catch (e) {
    console.error('Failed to connect to Firebase emulators:', e.message);
  }
}

export const firebaseAuth = firebaseOperationsApp.auth();
export const firebaseDb = firebaseEventsApp.database();
export const firestoreEventsDb = firebaseEventsApp.firestore();
export const firestoreOperationsDb = firebaseOperationsApp.firestore();
export const firestoreMasterDb = firebaseMasterApp.firestore();

/* eslint-disable no-console */
/* Suppress Firestore SDK debug logs (e.g. "false for 'get' @ L81") */
const suppressFirestoreLogs = (db) => {
  if (db && typeof db.setLogLevel === 'function') {
    db.setLogLevel('silent');
  }
};
if (firebase.firestore && firebase.firestore.setLogLevel) {
  firebase.firestore.setLogLevel('silent');
}
suppressFirestoreLogs(firestoreEventsDb);
suppressFirestoreLogs(firestoreOperationsDb);
suppressFirestoreLogs(firestoreMasterDb);
/* eslint-enable no-console */

export const firebaseAdminAuth = firebaseMasterApp.auth();
export const firebaseStorage = firebaseOperationsApp.storage();

export const operationsDb = firestoreOperationsDb;
export const masterDb = firestoreMasterDb;

export const firebaseMaster = firebase;

// Ensure user exists in the Firebase app Auth instances used by clinic users.
// The Firebase emulator has separate Auth per project, so a user created in
// operations doesn't exist in events. This creates the user in each app's Auth
// if sign-in fails. The master app is admin-only: signing a new clinic user
// into it would replace the super-admin session, so it is opt-in.
export async function signInToAllApps(email, password, { includeMaster = true } = {}) {
  const apps = includeMaster
    ? [firebaseOperationsApp, firebaseEventsApp, firebaseMasterApp]
    : [firebaseOperationsApp, firebaseEventsApp];
  for (const app of apps) {
    try {
      await app.auth().signInWithEmailAndPassword(email, password);
    } catch (e) {
      try {
        await app.auth().createUserWithEmailAndPassword(email, password);
      } catch (createErr) {
        try {
          await app.auth().signInWithEmailAndPassword(email, password);
        } catch (signInErr) {}
      }
    }
    if (app.auth().currentUser) {
      await app.auth().currentUser.getIdToken(true);
    }
  }
}

// Refresh ID tokens for all apps before Firestore operations.
export async function refreshAllTokens() {
  const apps = [firebaseOperationsApp, firebaseEventsApp, firebaseMasterApp];
  for (const app of apps) {
    const user = app.auth().currentUser;
    if (user) {
      await user.getIdToken(true);
    }
  }
}
